<template>
	<div class="yszck">
		<div class="fhan" @click='gosy()'>返回</div>
		<div class="nrk" v-html="nr"></div>
	</div>
</template>

<style scoped>
.nrk{
	width: 100%;
	box-sizing: border-box;
	padding-left: 24px;
	padding-right: 24px;
}
.fhan{
	width: 100%;
	height: 100px;
	font-size: 30px;
	color: #000000;
	box-sizing: border-box;
	padding-left: 40px;
	line-height: 100px;
	cursor: pointer;
}
.yszck{
	width: 100%;
}
.yszcbt{
	font-size: 30px;
	color: #000000;
	width: 100%;
	text-align: center;
}
.yszcnr{
	color: #464646;
	font-size: 23px;
	width: 100%;
	box-sizing: border-box;
	padding-left: 43px;
	padding-right: 43px;
	margin-top: 30px;
	text-indent: 2ch;
}
.foot{
	width: 100%;
	background: #f5f9fa;
	margin-top: 50px;
	color: #68747f;
	line-height: 30px;
	text-align: center;
	font-size: 18px;
	padding-top: 20px;
	padding-bottom: 20px;
}
.foot a{
	color: #68747f!important;
	text-decoration: none;
}
</style>

<script>
export default {
	name: 'privacy',
	data () {
		return {
			nr:''
		}
	},
	mounted () {
		let that = this;
		that.id = that.$route.params.id;
		this.$http('/policy').then(function (res) {
			that.nr = res.data.data[0].nr;
		}).catch(function (error) {
			
		});
	},
	methods: {
		gosy(){
			this.$router.push({
				path: `/index`
			})
		}
	}
};
</script>